$(document).ready(function() {
    var megamenu_active = false; // Initialize Megamenu as false
    var megamenu_con = $('.megamenu-con');

    $(".menu-list-con .menu_item").hover(
        function() {
            console.log("1. menu item hovered");
            var data_menuid =  $(this).attr("id");
            console.log("get id " + data_menuid);
            var current_active = false;
            if ($(this).hasClass('active')){
                current_active = true;
            }
            console.log("is current active: " + current_active);

            if(current_active){
                console.log("has active class");
            } else {

            // Check if the megamenu element exists
                if ($(".megamenu-id-" + data_menuid).length) {
                    console.log("menu item has megamenu");
                    megamenu_active = true; // Set Megamenu to true if it exists

                    console.log("Megamenu exists for data-menuid: " + data_menuid);
                    console.log("alternative menu is active");
                        // Fade out all active megamenus
                        $(".megamenu.active").fadeOut(400);
                        // remove class active from megamenu and menu button
                        $(".megamenu.active").removeClass('active').addClass('inactive');
                        $(".menu_item.active").removeClass('active').addClass('inactive');
                        //make hovered megamenu fadein
                        $(".megamenu-id-" + data_menuid).stop().fadeIn(200);
                        //add class active to megamenu and menu button
                        $(".megamenu-id-" + data_menuid).addClass('active').removeClass('inactive');
                        $(this).addClass('active').removeClass('inactive');
                        $(".overlaid-gradient").stop().fadeIn(200);
                        //fade in full menu container
                        //megamenu_con.fadeIn(200);

                } else {
                    console.log("menu item is standard");
                    megamenu_active = false; // Set Megamenu to false if it doesn't exist
                    console.log("Megamenu does not exist for data-menuid: " + data_menuid);
                    $(".megamenu.active").stop().fadeOut(400);
                    $(".megamenu.active").removeClass('active').addClass('inactive');
                    $(".menu_item.active").removeClass('active').addClass('inactive');
                    $(".overlaid-gradient").stop().fadeOut(400);
                    

                }
            }
        },
        function() {
            // When hovered out
            // Additional actions if needed
        }
    );

    $(".closemega").mouseleave(function(){
        // Code to execute when mouse leaves the <header> element
        $(".megamenu.active").stop().fadeOut(400);
        $(".megamenu.active").removeClass('active').addClass('inactive');
        $(".menu_item.active").removeClass('active').addClass('inactive');
        $(".overlaid-gradient").stop().fadeOut(400);
    });

    $(".infosection .menu_item").hover(
        function() {
            console.log("1. menu item hovered");
            var data_menuid =  $(this).attr("id");
            console.log("get id " + data_menuid);
            var current_active = false;
            if ($(this).hasClass('active_section')){
                current_active = true;
            }
            console.log("is current active: " + current_active);

            if(current_active){
                console.log("has active class");
            } else {
                $('.active-section').removeClass('active-section');
                $( this ).addClass('active-section');
                console.log('.sectionname-' + data_menuid);
                $('.sectionname-' + data_menuid).addClass('active-section');

            }
        },
        function() {
            // When hovered out
            // Additional actions if needed
        }
    );
});

$(document).ready(function() {
    $('.convert-imgtag').each(function() {
        console.log('running convert img tag to image');
        var content = $(this).html();
        var imgTagPattern = /\[img\](.*?)\[\/img\]/g;
        var newContent = content.replace(imgTagPattern, function(match, imgurl) {
            return '<img style="max-width: 300px" src="' + imgurl + '">';
        });
        $(this).html(newContent);
    });
});

